import Box from '@ilg-totallymoney/ui/components/Box'
import CategoryNavigation from '@ilg-totallymoney/ui/components/CategoryNavigation'
import Grid from '@ilg-totallymoney/ui/components/Grid'

import { CreditCardAlternativeProductsCategory } from '@appTypes/EligibilityApi.interface'

interface AlternativeProductsTableHeaderProps {
    categories: CreditCardAlternativeProductsCategory[]
    initialCategory: string
    onCategoryChange: (category: string) => void
}

const AlternativeProductsTableHeader = ({
    initialCategory,
    categories,
    onCategoryChange,
}: AlternativeProductsTableHeaderProps) => {
    return (
        <Grid>
            <Box
                gridColumn="1/13"
                ml="-space10"
                data-testid="alternative-products-category-navigation"
            >
                <CategoryNavigation
                    categories={categories.map(category => ({
                        displayName: `${category.displayName} (${category.alternativeProductsCount})`,
                        value: category.id,
                        url: `/alternative-products`,
                    }))}
                    hasPadding={false}
                    initialActiveCategory={initialCategory}
                    onCategoryChange={category => {
                        onCategoryChange?.(category.value)
                    }}
                />
            </Box>
        </Grid>
    )
}

export default AlternativeProductsTableHeader
